import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { advertisementTableColumnsConfig } from "./advertisementTableColumnDef";
import { Table } from "../../../component/table/Table";


export const AdvertisementTablePage = ({ data }) => {
  const [columnDefs, setColumnDefs] = useState([]);
  const navigate = useNavigate();

  const handleNavigateToDetail = useCallback(
    (rowData) => {
      navigate(`${rowData.id}`);
    },

    [navigate]
  );

  useEffect(() => {
    setColumnDefs(
      advertisementTableColumnsConfig["advertisement"](handleNavigateToDetail)
    );
  }, [handleNavigateToDetail]);

  return <Table data={data} columns={columnDefs} />;
};
